import { useTranslation } from 'react-i18next';
import { Modal } from 'antd';
import { ApsButton, ApsModalBody, ApsSubmissionStatus } from 'UserExperience/portal-vnext';

const SubmissionModal = ({ visible, submissionComplete, confirmationNumber, onOk, onCancel }) => {

  const { t } = useTranslation();
  const uploadingText = t('uploadScreen.submissionModal.uploading');
  const submissionCompleteText = t('uploadScreen.submissionModal.submissionComplete');
  const errorText = t('uploadScreen.submissionModal.somethingWrong');
  const retryText = t('uploadScreen.submissionModal.tryAgain');
  const confirmationText = t('uploadScreen.submissionModal.confirmation') + ' ' + (confirmationNumber || '');
  const startNewText = t('uploadScreen.submissionModal.startNew');

  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      closable={false}
      maskClosable={false}
      footer = {null}
      centered={true}
      wrapClassName="modal-size-is-small"
      bodyStyle={{padding:0, fontSize: 16}}
      width={280}
      destroyOnClose={true}
    >
      {/* existing portal css needs some wrapper element so modal font, etc., will be applied */}
      <emulate-ng-include>
        <ApsModalBody>
          {!submissionComplete &&
          <ApsSubmissionStatus
            id="uploadingStatus"
            state="uploading"
            textUploading={uploadingText}
          />
          }
          {submissionComplete && confirmationNumber &&
          <ApsSubmissionStatus
            id="completeStatus"
            state="complete"
            title={submissionCompleteText}
            subtitle={confirmationText}
          >
            <ApsButton
              buttonLabel={startNewText}
              buttonShape="pill"
              buttonType="primary"
              onClick={onOk}
            />
          </ApsSubmissionStatus>
          }
          {submissionComplete && !confirmationNumber &&
          <ApsSubmissionStatus
            id="errorStatusStatus"
            state="error"
            textError={errorText}
          >
            <ApsButton
              buttonLabel={retryText}
              buttonShape="pill"
              buttonType="primary"
              onClick={onCancel}
            />
          </ApsSubmissionStatus>
          }
        </ApsModalBody>
      </emulate-ng-include>
    </Modal>
  );
};

export default SubmissionModal;